import React from 'react';

const SecuritySignal: React.FC = () => (
  <div className="qssn-control-matrix" aria-label="Controls being verified and recorded">
    {Array.from({ length: 24 }, (_, index) => (
      <span key={index} className="qssn-control-matrix__dot" aria-hidden="true" style={{ '--dot-index': index } as React.CSSProperties} />
    ))}
  </div>
);

export default SecuritySignal;
